import type { Address } from "@opensea/wallet"
import { parseAsString, useQueryState } from "nuqs"
import { QUERY_PARAM_KEYS } from "./keys"

export function useSenderQueryParam(): {
  sender: Address | undefined
  setSender: (sender: Address | undefined) => void
} {
  const [sender, setSender] = useQueryState(
    QUERY_PARAM_KEYS.sender,
    parseAsString.withDefault(""),
  )

  return {
    sender,
    setSender: (sender: Address | undefined) => {
      setSender(sender ?? null)
    },
  }
}
